import { render } from "./ModifyPassword.vue?vue&type=template&id=3e5a1e15&scoped=true"
import script from "./ModifyPassword.vue?vue&type=script&lang=js"
export * from "./ModifyPassword.vue?vue&type=script&lang=js"

import "./ModifyPassword.vue?vue&type=style&index=0&id=3e5a1e15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5a1e15"]])

export default __exports__